var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pt-12 mt-2 pb-1" },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs10: "", "offset-xs1": "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "pb-0" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { staticClass: "pb-0", attrs: { xs7: "" } },
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "pr-12",
                                    attrs: { type: "card" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                {
                                  staticClass: "my-0",
                                  attrs: { "justify-end": "true" },
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs5: "" } },
                                    [
                                      _c("v-skeleton-loader", {
                                        staticClass: "my-3",
                                        attrs: { type: "sentences" },
                                      }),
                                      _c("v-skeleton-loader", {
                                        staticClass: "my-3",
                                        attrs: { type: "button" },
                                      }),
                                      _c("v-skeleton-loader", {
                                        staticClass: "my-3",
                                        attrs: { type: "button" },
                                      }),
                                      _c("v-skeleton-loader", {
                                        staticClass: "my-3",
                                        attrs: { type: "button" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs10: "", "offset-xs1": "" } },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "py-5",
                    attrs: { type: "heading" },
                  }),
                  _vm._l(6, function (i) {
                    return _c(
                      "v-card",
                      { key: i },
                      [
                        _c("v-skeleton-loader", {
                          attrs: { type: "list-item-avatar-two-line" },
                        }),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }